import * as React from 'react'
const DemoFormContainer = (props) => {

    return (
    <>
    <div className="container">
        <div className="row">
            <div className="col-12">
                <h3>{props.header}</h3>
            </div>
        </div>        
        <div className="row">
            <div className="col-12">
                <iframe id={props.id} title={props.title} src={props.src} width="100%" height={props.height} scrolling="no" type="text/html" frameborder="0" allowtransparency="true"></iframe>
            </div>
        </div>
    </div>
    {/* <Script isHydrating={true} type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js" />
    <Script isHydrating={true} type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/4.2.11/iframeResizer.min.js" />
    <Script type="text/javascript">
        iFrameResize(log:true);
    </Script> */}
    </>
    )
}

export default DemoFormContainer

